import React from "react";
import { Link } from "react-router-dom";
import CompanyForm from "./Companyform"; // Adjust the import path as necessary
import './onioncomp.css'; // Adjust the CSS file path as necessary

const PurvanshElectricalComp = () => {
    // Company data for Purvansh Electrical Trading and Training
    const companyData = {
        name: "Rakesh Singh",
        email: "AaravInternational.jal@gmail.com",
        mobileNumber: "6268284606",
        companyName: "PURVANSH ELECTRICAL TRADING AND TRAINING",
        productOrService: "Solar Panels",
        productDescribe: "Purvansh Electrical Trading and Training specializes in high-quality solar panels and related electrical training. We offer a range of solar panel solutions for residential and commercial applications, ensuring efficient and sustainable energy solutions.",
        businessType: "Supplier and Trainer",
        mainProducts: "Solar Panels, Electrical Training",
        logoUrl: "/assets/solarpanel1.jpeg", // Placeholder path to company logo image
    };

    return (
        <>
            <div className="container">
                <ol className="breadcrumb">
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px 30px' }} className="breadcrumb-item">
                        <Link to={'/'}>Home</Link>
                    </li>
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px -25px' }} >/</li>
                    <li style={{ display: 'flex', justifyContent: 'center', margin: '5px 30px' }} className="breadcrumb-item active">Search</li>
                </ol>
            </div>
            <div className="b2b-page">
                <div className="content-left">
                    {/* Display Purvansh Electrical Trading and Training information */}
                    <div className="company-card">
                        <div className="company-header">
                            <div className="company-logo">
                                <img src={companyData.logoUrl} alt="Company Logo" />
                            </div>
                            <div className="company-details">
                                <h3>{companyData.companyName}</h3>
                                <p><strong>Description:</strong> {companyData.productDescribe}</p>

                                <div className="imp-btns">
                                    <button style={{ backgroundColor: '#4ee54e' }} className="main-btns">
                                        <Link to={'/register-buyer'}>Connect Now</Link>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p><strong>Business Type:</strong> {companyData.businessType}</p>
                        <p><strong>Main Products:</strong> {companyData.mainProducts}</p>
                    </div>
                </div>
                <CompanyForm />
            </div>
        </>
    );
}

export default PurvanshElectricalComp;
